// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2_p-e","left":"StickyBox_left__1jgCH","right":"StickyBox_right__1BnCs"};